import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { IRecommendationTask } from '../../../interfaces/route-recommendations/recommendation-task';
import { IVehicleAddress } from '../../../interfaces/task-info';
import format from 'date-fns/format';
import isSameDay from 'date-fns/isSameDay';
import { isSameHour, isSameMinute } from 'date-fns';
@Component({
  selector: 'task-and-location-container',
  templateUrl: './task-and-location-container.component.html',
  styleUrls: ['./task-and-location-container.component.scss', './vertical-list-dots.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaskAndLocationContainerComponent {
  @HostBinding('class.flex-grow-1') flexGrow = true;

  @Input() isPickup: boolean = false;

  @Input() plannedTask: IRecommendationTask;

  @Input() isCarryOver: boolean;

  @Input() location: {
    businessName?: string;
    city?: string;
    postcode?: string;
    postal_town?: string;
    street_number?: string;
    addressLine1?: string;
    addressLine2?: string;
    addressLine3?: string;
  };

  @Input() isFirstItem: boolean;

  @Input() isLastItem: boolean;

  @Input() showTaskBadges: boolean;

  @Input() earliestDateTime: string;

  @Input() latestDateTime: string;

  @Input() taskNumber: number;

  @Input() arriveHomeEarliest!: string;
  @Input() arriveHomeLatest!: string;
  @Input() leaveHomeEarliest!: string;
  @Input() leaveHomeLatest!: string;

  get addressLineDisplay(): string {
    const parts = [this.location?.businessName, this.location?.city, this.location?.postcode];
    return parts
      .filter((x) => x && x.length > 0)
      .map((x) => x.trim())
      .join(', ');
  }

  get earliestAsDateInstance(): Date {
    return new Date(this.earliestDateTime);
  }

  get latestAsDateInstance(): Date {
    return new Date(this.latestDateTime);
  }

  public get dateString(): string {
    return this.formatDateString(this.earliestDateTime, this.latestDateTime);
  }

  public get timeString(): string {
    return this.formatTimeString(this.earliestDateTime, this.latestDateTime);
  }

  formatDateString(earliestDateTime: string, latestDateTime: string): string {
    const earliestAsDateInstance = new Date(earliestDateTime);
    const latestAsDateInstance = new Date(latestDateTime);
    let result = format(new Date(earliestDateTime), 'EEE do MMM');
    if (isSameDay(latestAsDateInstance, earliestAsDateInstance)) {
      return result;
    }
    return result + ' - ' + format(latestAsDateInstance, 'EEE do MMM');
  }

  formatTimeString(earliestDateTime: string, latestDateTime: string): string {
    const earliestAsDateInstance = new Date(earliestDateTime);
    const latestAsDateInstance = new Date(latestDateTime);
    let result = format(earliestAsDateInstance, 'H:mm');
    if (
      isSameHour(latestAsDateInstance, earliestAsDateInstance) &&
      isSameMinute(latestAsDateInstance, earliestAsDateInstance)
    ) {
      return result;
    }
    return result + ' - ' + format(latestAsDateInstance, 'H:mm');
  }
}
